<template>
  <v-card class="pa-4 ma-0" elevation="0">
    <div style="width: 100%; padding: 20px 0">
      <v-card-title class="card-title pl-0"><b>Clientes</b> </v-card-title>
      <span class="card-text">
        Veja todos os clientes cadastrados, veja detalhes.
      </span>
    </div>

    <div class="d-flex justify-center">
      <v-btn
        outlined
        tile
        icon
        class="quinary-button hidden-sm-and-up"
        style="border-radius: 5px"
      >
        <v-icon>mdi-download</v-icon>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style>
.card-title {
  font-family: Roboto;
  font-size: 1.5rem !important;
}

.card-text {
  display: flex;
  justify-content: space-between;

  font-family: Roboto;
  font-size: 1rem;
  font-weight: 300;
  line-height: 30px;

  width: 70%;

  color: #9c9c9c;
}
</style>
